// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-card {
  background: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #3d3d3d;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
  width: 100%;
  height: 100%;
  min-height: 0;
  /* Permite overlays (header/controls) sin afectar el tamaño del video */
  position: relative;
}

.video-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.video-card-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 6px 8px;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 35;
  transition: opacity 0.3s ease;
  opacity: 1;
}

.video-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.video-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.video-header-btn {
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #ffffff;
  width: 30px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.video-header-btn:hover {
  background: rgba(220, 38, 38, 0.85);
  border-color: rgba(220, 38, 38, 0.9);
}

.video-header-btn-refresh {
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-card-header.hidden {
  opacity: 0;
  pointer-events: none;
}

.video-card-header.visible {
  opacity: 1;
  pointer-events: auto;
}

.camera-name {
  font-weight: 600;
  color: #ffffff;
  font-size: 13px;
}

.camera-status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-text {
  font-size: 12px;
  color: #999;
  font-weight: 500;
}

/* Título permanente con viñetado negro en la parte superior del video */
.video-title-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 16px 12px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.82) 0%,
    rgba(0, 0, 0, 0.55) 50%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.video-title-name {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1 1;
}

.video-title-status {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

.video-title-status-text {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
  white-space: nowrap;
}

.video-container {
  position: relative;
  width: 100%;
  flex: 1 1;
  min-height: 0;
  background: #000;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-container.zoomed {
  cursor: grab;
  touch-action: none; /* permite pan en touch sin scroll de página dentro del video */
}

.video-container.zoomed.panning {
  cursor: grabbing;
}

.video-container:not(.zoomed):not(.ptz-active) {
  cursor: zoom-in;
}

/* PTZ arrastrar / rueda: mismos gestos que con WHEP (sobre el iframe) */
.video-container.ptz-active {
  cursor: move;
  touch-action: none;
}

.video-container.ptz-active.ptz-dragging {
  cursor: grabbing;
}

/* Fullscreen: contenedor ocupa todo el viewport para que zoom/pan sigan funcionando */
.video-container:fullscreen,
.video-container:-webkit-full-screen {
  width: 100vw;
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
  flex: none;
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Mostrar el frame completo sin recortar (puede dejar barras negras laterales/arriba-abajo) */
  object-fit: contain;
  object-position: center;
}

/* Player HTML de MediaMTX: el iframe no captura eventos (PTZ / zoom digital van al contenedor). */
.video-player-iframe {
  object-fit: unset;
  background: #000;
  pointer-events: none;
  will-change: transform;
}

/* Capa transparente que recibe gestos cuando hay iframe (misma UX que <video> + WHEP). */
.video-interaction-overlay {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: transparent;
  touch-action: none;
}

.video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #1a1a1a;
  color: #666;
}

.placeholder-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.placeholder-text {
  font-size: 14px;
}

.placeholder-hint {
  font-size: 12px;
  color: #888;
  margin-top: 8px;
}

.reconnecting-indicator {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.reconnecting-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(166, 27, 52, 0.3);
  border-top-color: #A61B34;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* fullscreen moved into header buttons */

.video-controls {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid #3d3d3d;
  /* Overlay inferior: fuera del flujo para que el video NO cambie de tamaño al ocultar/mostrar */
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 30;
  justify-content: center;
  transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease;
  opacity: 1;
  transform: translateY(0);
  max-height: 50px;
}

.ptz-toggle-btn {
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
}

.ptz-toggle-btn.active {
  background: rgba(59, 130, 246, 0.8);
  border-color: rgba(59, 130, 246, 0.95);
}

.ptz-home-btn {
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.ptz-home-btn:hover {
  background: rgba(0, 0, 0, 0.85);
}

.ptz-error-toast {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 25;
  max-width: calc(100% - 24px);
  padding: 6px 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.85);
  color: #f87171;
  font-size: 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.video-container.ptz-dragging {
  cursor: move;
}

/* PTZ - legacy panels (replaced by drag + wheel, kept for reference) */
.ptz-left-panel {
  position: absolute;
  left: 12px;
  bottom: 58px; /* above bottom controls */
  z-index: 35;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: calc(100% - 24px);
}

.ptz-right-panel {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 35;
}

.ptz-dpad {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(6px);
  overflow: hidden;
}

.ptz-dir {
  position: absolute;
  background: rgba(0, 0, 0, 0.45);
  border: none;
  color: rgba(255, 255, 255, 0.95);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.ptz-dir:hover {
  background: rgba(0, 0, 0, 0.65);
}

.ptz-dir:active {
  background: rgba(59, 130, 246, 0.75);
}

.ptz-up {
  top: 0;
  left: 25%;
  right: 25%;
  height: 38%;
}

.ptz-down {
  bottom: 0;
  left: 25%;
  right: 25%;
  height: 38%;
}

.ptz-left {
  left: 0;
  top: 25%;
  bottom: 25%;
  width: 38%;
}

.ptz-right {
  right: 0;
  top: 25%;
  bottom: 25%;
  width: 38%;
}

.ptz-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}

.ptz-center:hover {
  background: rgba(0, 0, 0, 0.85);
}

.ptz-center:active {
  background: rgba(59, 130, 246, 0.75);
}

.ptz-speed {
  width: 260px;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  padding: 8px 10px;
  backdrop-filter: blur(6px);
  max-width: calc(100vw - 48px);
}

.ptz-speed-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 6px;
}

.ptz-speed-seg {
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.ptz-speed-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ptz-zoom-inline {
  display: flex;
  gap: 8px;
  align-items: center;
}

.ptz-speed-btn {
  background: rgba(0, 0, 0, 0.35);
  border: none;
  color: rgba(255, 255, 255, 0.85);
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}

.ptz-speed-btn:hover {
  background: rgba(0, 0, 0, 0.55);
}

.ptz-speed-btn.active {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.ptz-zoom-btn {
  width: 46px;
  height: 38px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.ptz-zoom-btn:hover {
  background: rgba(0, 0, 0, 0.65);
}

.ptz-zoom-btn:active {
  background: rgba(59, 130, 246, 0.75);
  border-color: rgba(59, 130, 246, 0.95);
}

.ptz-toast {
  max-width: 260px;
  background: rgba(220, 38, 38, 0.75);
  border: 1px solid rgba(220, 38, 38, 0.9);
  color: #fff;
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 12px;
  backdrop-filter: blur(6px);
}

.video-controls.hidden {
  opacity: 0;
  transform: translateY(100%);
  max-height: 0;
  padding: 0;
  overflow: hidden;
  pointer-events: none;
}

.video-controls.visible {
  opacity: 1;
  transform: translateY(0);
  max-height: 50px;
  pointer-events: auto;
}


.reconnect-btn {
  padding: 6px 12px;
  background: #f59e0b;
  border: 1px solid #f59e0b;
  border-radius: 4px;
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
}

.reconnect-btn:hover {
  background: #d97706;
  border-color: #d97706;
}

.reconnect-btn:active {
  transform: scale(0.95);
}
`, "",{"version":3,"sources":["webpack://./src/components/VideoCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B;;;;;GAKC;EACD,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB,EAAE,+DAA+D;AACrF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8FAA8F;EAC9F,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kGAAkG;AAClG;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,yFAAyF;AACzF;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,+FAA+F;EAC/F,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,wEAAwE;EACxE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,0BAA0B;EACxC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;EACxC,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;AACtB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".video-card {\n  background: #2d2d2d;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #3d3d3d;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s, box-shadow 0.2s;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  /* Permite overlays (header/controls) sin afectar el tamaño del video */\n  position: relative;\n}\n\n.video-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.video-card-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 6px 8px;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 35;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n}\n\n.video-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.video-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.video-header-btn {\n  background: rgba(0, 0, 0, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n  width: 30px;\n  height: 26px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 1;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.video-header-btn:hover {\n  background: rgba(220, 38, 38, 0.85);\n  border-color: rgba(220, 38, 38, 0.9);\n}\n\n.video-header-btn-refresh {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-card-header.hidden {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.video-card-header.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.camera-name {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 13px;\n}\n\n.camera-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.status-text {\n  font-size: 12px;\n  color: #999;\n  font-weight: 500;\n}\n\n/* Título permanente con viñetado negro en la parte superior del video */\n.video-title-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px 16px 12px;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.82) 0%,\n    rgba(0, 0, 0, 0.55) 50%,\n    rgba(0, 0, 0, 0) 100%\n  );\n  pointer-events: none;\n  user-select: none;\n}\n\n.video-title-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  flex: 1;\n}\n\n.video-title-status {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n}\n\n.video-title-status-text {\n  font-size: 11px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.85);\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);\n  white-space: nowrap;\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  background: #000;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-container.zoomed {\n  cursor: grab;\n  touch-action: none; /* permite pan en touch sin scroll de página dentro del video */\n}\n\n.video-container.zoomed.panning {\n  cursor: grabbing;\n}\n\n.video-container:not(.zoomed):not(.ptz-active) {\n  cursor: zoom-in;\n}\n\n/* PTZ arrastrar / rueda: mismos gestos que con WHEP (sobre el iframe) */\n.video-container.ptz-active {\n  cursor: move;\n  touch-action: none;\n}\n\n.video-container.ptz-active.ptz-dragging {\n  cursor: grabbing;\n}\n\n/* Fullscreen: contenedor ocupa todo el viewport para que zoom/pan sigan funcionando */\n.video-container:fullscreen,\n.video-container:-webkit-full-screen {\n  width: 100vw;\n  height: 100vh;\n  max-width: 100%;\n  max-height: 100%;\n  flex: none;\n}\n\n.video-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* Mostrar el frame completo sin recortar (puede dejar barras negras laterales/arriba-abajo) */\n  object-fit: contain;\n  object-position: center;\n}\n\n/* Player HTML de MediaMTX: el iframe no captura eventos (PTZ / zoom digital van al contenedor). */\n.video-player-iframe {\n  object-fit: unset;\n  background: #000;\n  pointer-events: none;\n  will-change: transform;\n}\n\n/* Capa transparente que recibe gestos cuando hay iframe (misma UX que <video> + WHEP). */\n.video-interaction-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  background: transparent;\n  touch-action: none;\n}\n\n.video-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 15;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #1a1a1a;\n  color: #666;\n}\n\n.placeholder-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.placeholder-text {\n  font-size: 14px;\n}\n\n.placeholder-hint {\n  font-size: 12px;\n  color: #888;\n  margin-top: 8px;\n}\n\n.reconnecting-indicator {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.reconnecting-spinner {\n  width: 24px;\n  height: 24px;\n  border: 3px solid rgba(166, 27, 52, 0.3);\n  border-top-color: #A61B34;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* fullscreen moved into header buttons */\n\n.video-controls {\n  display: flex;\n  gap: 8px;\n  padding: 8px 12px;\n  background: rgba(0, 0, 0, 0.2);\n  border-top: 1px solid #3d3d3d;\n  /* Overlay inferior: fuera del flujo para que el video NO cambie de tamaño al ocultar/mostrar */\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 30;\n  justify-content: center;\n  transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease;\n  opacity: 1;\n  transform: translateY(0);\n  max-height: 50px;\n}\n\n.ptz-toggle-btn {\n  background: rgba(0, 0, 0, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.ptz-toggle-btn.active {\n  background: rgba(59, 130, 246, 0.8);\n  border-color: rgba(59, 130, 246, 0.95);\n}\n\n.ptz-home-btn {\n  background: rgba(0, 0, 0, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #fff;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.ptz-home-btn:hover {\n  background: rgba(0, 0, 0, 0.85);\n}\n\n.ptz-error-toast {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 25;\n  max-width: calc(100% - 24px);\n  padding: 6px 12px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.85);\n  color: #f87171;\n  font-size: 12px;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.video-container.ptz-dragging {\n  cursor: move;\n}\n\n/* PTZ - legacy panels (replaced by drag + wheel, kept for reference) */\n.ptz-left-panel {\n  position: absolute;\n  left: 12px;\n  bottom: 58px; /* above bottom controls */\n  z-index: 35;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-width: calc(100% - 24px);\n}\n\n.ptz-right-panel {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 35;\n}\n\n.ptz-dpad {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  backdrop-filter: blur(6px);\n  overflow: hidden;\n}\n\n.ptz-dir {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.45);\n  border: none;\n  color: rgba(255, 255, 255, 0.95);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.ptz-dir:hover {\n  background: rgba(0, 0, 0, 0.65);\n}\n\n.ptz-dir:active {\n  background: rgba(59, 130, 246, 0.75);\n}\n\n.ptz-up {\n  top: 0;\n  left: 25%;\n  right: 25%;\n  height: 38%;\n}\n\n.ptz-down {\n  bottom: 0;\n  left: 25%;\n  right: 25%;\n  height: 38%;\n}\n\n.ptz-left {\n  left: 0;\n  top: 25%;\n  bottom: 25%;\n  width: 38%;\n}\n\n.ptz-right {\n  right: 0;\n  top: 25%;\n  bottom: 25%;\n  width: 38%;\n}\n\n.ptz-center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.ptz-center:hover {\n  background: rgba(0, 0, 0, 0.85);\n}\n\n.ptz-center:active {\n  background: rgba(59, 130, 246, 0.75);\n}\n\n.ptz-speed {\n  width: 260px;\n  background: rgba(0, 0, 0, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 10px;\n  padding: 8px 10px;\n  backdrop-filter: blur(6px);\n  max-width: calc(100vw - 48px);\n}\n\n.ptz-speed-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.85);\n  margin-bottom: 6px;\n}\n\n.ptz-speed-seg {\n  display: inline-flex;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.ptz-speed-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.ptz-zoom-inline {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.ptz-speed-btn {\n  background: rgba(0, 0, 0, 0.35);\n  border: none;\n  color: rgba(255, 255, 255, 0.85);\n  padding: 6px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.ptz-speed-btn:hover {\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.ptz-speed-btn.active {\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n}\n\n.ptz-zoom-btn {\n  width: 46px;\n  height: 38px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.ptz-zoom-btn:hover {\n  background: rgba(0, 0, 0, 0.65);\n}\n\n.ptz-zoom-btn:active {\n  background: rgba(59, 130, 246, 0.75);\n  border-color: rgba(59, 130, 246, 0.95);\n}\n\n.ptz-toast {\n  max-width: 260px;\n  background: rgba(220, 38, 38, 0.75);\n  border: 1px solid rgba(220, 38, 38, 0.9);\n  color: #fff;\n  border-radius: 10px;\n  padding: 8px 10px;\n  font-size: 12px;\n  backdrop-filter: blur(6px);\n}\n\n.video-controls.hidden {\n  opacity: 0;\n  transform: translateY(100%);\n  max-height: 0;\n  padding: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.video-controls.visible {\n  opacity: 1;\n  transform: translateY(0);\n  max-height: 50px;\n  pointer-events: auto;\n}\n\n\n.reconnect-btn {\n  padding: 6px 12px;\n  background: #f59e0b;\n  border: 1px solid #f59e0b;\n  border-radius: 4px;\n  color: #ffffff;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n}\n\n.reconnect-btn:hover {\n  background: #d97706;\n  border-color: #d97706;\n}\n\n.reconnect-btn:active {\n  transform: scale(0.95);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
